<template>
  <div class="navbar" style="position: relative; z-index: 20;">
    <template v-if="activeSearch">
      <Search @close="activeSearch = false" :q="qSearch" />

      <div class="navbar__items navbar__items--left navbar__items--search">
        <input placeholder="Caută în platformă" ref="SearchInput" v-model="qSearch" />
      </div>

      <div class="navbar__items navbar__items--right">
        <div class="navbar__item">
          <i class="fas fa-times" @click="activeSearch = false" />
        </div>
      </div>
    </template>

    <template v-else>
      <div class="navbar__items navbar__items--left">
        <div class="navbar__item" v-if="isMobile">
          <i class="fas fa-bars" id="sidebar-show" @click="$emit('change', true)"></i>
        </div>
      </div>

      <div class="dropdown-overlay" 
        :style="{
          display: active ? 'block' : 'none'
        }" 
        @click="active = !active">
      </div>

      <div class="navbar__items navbar__items--right">
        <div class="navbar__item">
            <i class="fas fa-search" @click="openSearch"></i>
        </div>

        <div class="navbar__item">
            <Notifications :isMobile="isMobile"/>
        </div>
        
        

        <div class="navbar__item">
          <div class="dropdown" id="profile-dropdown">
            <i class="dropdown__icon far fa-user" @click="active = !active, $store.state.layout.notifications.active = false"></i>
            <div class="dropdown__drawer"
              :style="{
                display: active ? 'block' : 'none'
              }">

              <router-link class="dropdown__item"
                v-if="isSpecialist" 
                :to="{ path: getProfileLink() , params: {} }" 
                tag="div">
                <div @click="close">
                  <i class="fas fa-user"></i> Profil
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>

              <router-link class="dropdown__item"
                to="/specialist/stats" tag="div" v-if="isSpecialist">
                <div @click="close">
                  <i class="fas fa-chart-bar"></i> Statistici
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>

              <router-link class="dropdown__item" 
                to="/client/payments" tag="div" v-else>
                <div @click="close">
                  <i class="fas fa-credit-card"></i> Plăți
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>

              <router-link class="dropdown__item"
                v-if="isSpecialist" 
                to="/specialist/transactions"
                tag="div">
                <div @click="close">
                  <i class="fas fa-file-invoice-dollar"></i> Tranzacții
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>

              <!--
              <router-link class="dropdown__item"
                v-if="isSpecialist" 
                :to="{ path: getSettingsLink(), params: {}, hash: 'disponibilitate' }" 
                tag="div">
                <div @click="close">
                  <i class="fas fa-clock"></i> Disponibilitate
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>
              -->

              <router-link class="dropdown__item"
                :to="{ path: getSettingsLink() , params: {} }" 
                tag="div">
                <div @click="close">
                  <i class="fas fa-cog"></i> Setări
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </router-link>

              <div class="dropdown__item" @click="logout">
                <div @click="close">
                  <i class="fas fa-sign-out-alt"></i> Logout
                  <i class="fas fa-chevron-left dropdown__arrow"></i>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Search from './Search';
import Notifications from './Notifications';

export default {
  components: { Search, Notifications },
  props: {
    isMobile: {}
  },
  data() {
    return {
      active       : false,
      activeSearch : false,
      qSearch      : ''
    };
  },
  methods: {
    ...mapActions({
      logout: 'user/logout'
    }),
    getSettingsLink() {
      return '/'+localStorage.getItem('role')+'/settings';
    },
    getPaymentsLink() {
      return '/'+localStorage.getItem('role')+'/payments';
    },
    getProfileLink() {
      return '/specialists/profile/'+this.user.id;
    },
    close() {
      this.active = false;
    },
    openSearch() {
      this.activeSearch = true;
      this.$store.state.layout.notifications.active = false;

      setTimeout(() => {
        this.$refs.SearchInput.focus();
      }, 200);
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    isSpecialist() {
      return localStorage.getItem('role') == 'specialist';
    },
    role() {
      return localStorage.getItem('role');
    },
  },
}
</script>

<style lang="scss">
.dropdown{
  position: relative;
  user-select: none;

  &__drawer{
    position: absolute;
    top: 50px;
    right: -100%;
    display: none;
    flex-direction: column;
    font-size: 20px;
    min-width: 120px;
    box-shadow: 0px 0px 5px #0000001A;
    background-color: white;
    padding: 15px;
    z-index: 10;
    min-width: 200px;
  }

  &__arrow{
    position: absolute;
    right: 0px;
    visibility: hidden;
  }

  &__item{
    transition: transform 0.5s;
    position: relative;

    i{
      margin-right: 8px;
    }

    &:hover .dropdown__arrow{
      visibility: visible;
    }

  }

  &__item + &__item{
    padding-top: 15px;
  }
}

.navbar__items--search {
  width: 100%;
  max-width: 1000px;
  & > input {
    border: none;
    font-family: 'DIN Pro';
    font-size: 20px;
    padding-left: 10px;
    width: 100%;

    &, &:focus {
      outline: none;
    }
  }
}
</style>